import * as e from "react";
const r = (l) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 32", ...l }, /* @__PURE__ */ e.createElement(
  "path",
  {
    d: "M21.828 19.243l-6.778-6.779a1 1 0 011.414-1.414l6.779 6.778v-3.242a1 1 0 012 0v5.657a.997.997 0 01-1 1h-5.657a1 1 0 010-2h3.242z",
    fill: "#C4C4CC",
    fillRule: "nonzero"
  }
));
export {
  r as default
};
